module.exports = __webpack_public_path__ + "img/appAsset-bankingLogo__bice.7616c342.svg";